module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAiCAYAAAAkjjtxAAAAAXNSR0IArs4c6QAAAUNJREFUWAnV2N0NgjAQAGAqDkSZgFfjFsZpnMHwpgOYqG9uAOXdWQB7hBIMLVz5vTYxBazt13qkl3qeY4VN8ZZlybIsO0AfQRC8GWPllP4wv91hGunaADZN02ue50/4KLiu7ZzPRoEVVtanOTGYvqzBOqwMhRhCAjPg1DZWMWzChmF4XiN+YbJoMAUsGkwFiwJTwg6CqWF7wRSxRjBVrBZMGdsBU8f+gV3ANmDACiE+RVFE8LAuQu5eD3Wzcf2Vu+kddtM9QJIkucgqgutW4XIivHW/6aXMDGH8W5X8rJUHzDHjKpdwKSSa5Mepl079VS6gmxV2Bd0BA5zySmvBlNFGMFV0L5giehBMDY0CU0KjwVTQVmAKaGuwCe37/pFz/oLvlyzWR1WAgeyuPu2Jl8Tp+h61wqoj2BHVqeVax61qbGfqH8scZTkA7ltuAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/common/images/left_gray.png
// module id = 919
// module chunks = 1